export default {
  logo: {
    label: 'Logo',
    tooltip: 'Wybrane logo jest wyświetlane w nagłówku każdego raportu.',
  },
  errors: {
    unsupportedFileType: 'Aktualne logo jest w nieobsługiwanym formacie pliku. Prześlij nowe logo.',
    logoLoadingFailure: 'Nie udało się załadować aktualnego logo. Zalecamy przesłanie nowego logo.',
  },
};
